












































































import MyDamageDetailSideCard from "@/components/report/user/MyDamageDetailSideCard.vue";
import Notifications from "@/components/thg/Notifications.vue";
import TableWrapper from "@/components/utility/TableWrapper.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { MrfiktivReportViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ProgressStatusEnum } from "@/store/enum/partner/progress.status.enum";
import { DamageFleetModule } from "@/store/modules/fleet/damage-fleet.store";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";

// A map of states and colors
export const REPORT_COLOR_BY_STATUS = new Map([
  [ProgressStatusEnum.DRAFT, "grey"],
  [ProgressStatusEnum.NEW, "secondary"],
  [ProgressStatusEnum.IN_PROGRESS, "primary"],
  [ProgressStatusEnum.FINISHED, "deep-purple lighten-1"],
  [ProgressStatusEnum.DELETED, "grey darken-3"]
]);

@Component({
  components: {
    LayoutReportWithBanner,
    Notifications,
    TableWrapper,
    MyDamageDetailSideCard
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class FleetDamageView extends Vue {
  loading = false;
  selectedId: string | null = null;

  get breadCrumbs(): IBreadcrumb[] {
    const breadCrumbs: IBreadcrumb[] = [];

    breadCrumbs.push({
      text: this.$t("nav.FleetTableView.description"),
      disabled: false,
      exact: true,
      to: {
        name: "FleetHomeView",
        params: {}
      }
    });

    breadCrumbs.push({
      text: this.$t("common.nouns.report"),
      disabled: false,
      exact: false,
      to: {
        name: "FleetDamageView",
        params: {}
      }
    });

    return breadCrumbs;
  }

  get partnerId() {
    return ReportModule.partner.id;
  }

  get fleetIds() {
    return UserModule.fleetPermission?.filter(p => p.partnerId === this.partnerId).map(p => p.fleetId);
  }

  get fleetId() {
    return FleetManagerModule.current?.id;
  }

  get fleet() {
    return FleetManagerModule.current;
  }

  get currentReport() {
    return DamageFleetModule.currentReport;
  }

  get items() {
    return DamageFleetModule.all;
  }

  get colorByStatus() {
    return REPORT_COLOR_BY_STATUS;
  }

  get i18n() {
    return this.$t("objects.report");
  }

  get headers() {
    return [
      {
        text: this.$t("objects.timestamp.created"),
        align: "left",
        width: 120,
        value: "timestamp.created"
      },
      {
        text: this.$t("objects.report.status"),
        align: "left",
        width: 180,
        value: "status"
      },
      {
        text: this.$t("objects.report.leasing.claimNumber").toString(),
        align: "left",
        width: 150,
        value: "claimNumber"
      },
      {
        text: this.$t("report.accidentDetails.date").toString(),
        align: "left",
        width: 120,
        value: "accidentDetails.date"
      },
      {
        text: this.i18n["numberplate"],
        align: "left",
        width: 120,
        value: "numberplate"
      },
      {
        text: this.i18n["damageType"],
        align: "left",
        value: "damageType"
      },
      {
        text: this.i18n["coverageType"],
        align: "left",
        value: "coverageType"
      },

      {
        text: this.i18n["tripType"],
        align: "left",
        value: "tripType"
      },
      {
        text: this.$t("components.partner.PartnerReportDetailInfoCard.damageLocator.title").toString(),
        align: "left",
        value: "damage"
      },

      {
        text: this.$t("report.currentLocation.title"),
        align: "left",
        value: "location"
      },
      { text: "", value: "controls", align: "right", sortable: false }
    ];
  }

  async mounted() {
    await this.load();
  }

  async load() {
    if (!this.fleetId) {
      return;
    }

    this.loading = true;

    try {
      await DamageFleetModule.getAll({ partnerId: this.partnerId, fleetId: this.fleetId });
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }

  async openDetail(item: MrfiktivReportViewModelGen) {
    this.$log.debug(item);

    if (!this.fleetId) {
      return;
    }

    this.loading = true;
    this.selectedId = null;

    try {
      const report = await DamageFleetModule.getOne({
        partnerId: this.partnerId,
        fleetId: this.fleetId,
        id: item._id
      });
      this.selectedId = report._id;
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }
}
